import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop } from 'lodash';
import StudentReportFilter from '../../../components/Filter/StudentReport.filter.component';
import ListForm from '../../../components/ListForm/ListForm.component';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { ABSENSI_HARIAN } from '../../../constants/student.constant';
import { ABSENSI_HARIAN_TABLE } from '../../../constants/student.constant';
import { validateRequiredFields } from '../../../utils/validation.util';
import { commaFormatted, normalizeAmount } from '../../../utils/transformer.util';
import { Button } from '../../../components/base/index';
import { ANALISA_DISPLINER_FORM_FIELDS} from '../../../constants/Student/displiner.constant';
import  BuatPelanggaranForm  from '../components/BuatPelanggaranForm.component';

export default class AnalisaDispliner extends Component {
    constructor(props) {
        super(props);
        this._onClickAdd = this._onClickAdd.bind(this);
        this._onClickEdit = this._onClickEdit.bind(this);
        this._onClickAddGroup = this._onClickAddGroup.bind(this);
        this._onClickSubmit = this._onClickSubmit.bind(this);
        this._onFormChange = this._onFormChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
      
        this.state= {
          coa: {
            loading: true,
            list: [],
    
          },
          form: {
            value: {},
            error: {},
          },
        };
      
      }
    
      _onClickAdd() {
        const { history } = this.props;
        history.push('/dashboard/kesiswaan/displiner/analisa-displiner-pelanggaran', { data: '' });
      }

      _onClickSubmit() {
        const { history } = this.props;
        history.push('/dashboard/kesiswaan/displiner/analisa-displiner-prestasi', { data: '' });
      }
    
      _onClickEdit(val) {
        const { history } = this.props;
        history.push('/dashboard/kesiswaan/pendaftaran', { data: val });
      }
    
      _onClickAddGroup() {
        const { history } = this.props;
        history.push('/dashboard/kesiswaan/displiner/buat-group');
      }
      _onFormChange(event) {
        const {
          name,
          value,
          dataset,
          checked,
          type,
        } = event.target;
        const {
          inputType = 'text', inputArray = false, arrayPosition = 0,
          fieldName,
        } = dataset;
        this.setState((prevState) => {
          let newList = [];
          let newListError = [];
          let formattedValue = value;
    
          if (inputType === 'number') {
            formattedValue = normalizeAmount(value);
          }
          if (inputArray) {
            if (type === 'checkbox') {
              formattedValue = checked;
            }
            newList = prevState.form.value[fieldName];
            newListError = prevState.form.error[fieldName];
            newList[arrayPosition][name] = formattedValue;
            if (name === 'code_of_account') {
              newList[arrayPosition].isCredit = value.type;
            }
            if (!isEmpty(newListError[arrayPosition])) {
              newListError[arrayPosition][name] = '';
            }
          }
          return {
            form: {
              value: {
                ...prevState.form.value,
                ...(inputArray
                  ? { [fieldName]: newList }
                  : { [name]: formattedValue }),
              },
              error: {
                ...prevState.form.error,
                ...(inputArray
                  ? { [fieldName]: newListError }
                  : { [name]: '' }),
              },
            },
          };
        });
      }

      onSubmit(e) {
        e.preventDefault();
        // const { form} = this.state;
        const { form } = this.state;
        const { handleAddBudget, history, user } = this.props;
        const { workingUnit, prm_school_units_id } = user;
    
        let unit_id = prm_school_units_id;
    
        if (unit_id === null && workingUnit && workingUnit.id) {
          unit_id = workingUnit.id;
        }
        handleAddBudget(form.value, history.goBack, unit_id);
        // handleAddBudget(form.value, plafon, history.goBack, unit_id);
        //handleAddBudget(form.value, history.goBack, unit_id);
      }
      
    
      render() {
        const {form} = this.state;
        const { handleGetKelas, handleDeleteKelas,coa } = this.props;
        return (
            <div className="add-budget">
        
            <form onSubmit={this.onSubmit}>
              <div className="budget__title">
                <h1>Analisa Displiner</h1>
                <hr></hr>
              </div>
              
              <ListForm
              form={form}
              formFields={ANALISA_DISPLINER_FORM_FIELDS}
              onFormChange={this._onFormChange}
              />
               <div className="student-list__button">
                <Button
                  title="Submit"
                  onClick={this._onClickAdd}
                />
              </div>
             
    
            {/* <div className="budget__content">
              <div className="budget__search">
              <ListForm
              coa={coa}
              form={form}
              formFields={SEARCH_FIELDS}
              onFormChange={this._onFormChange}
              />
    
              </div>
              <ContentTable
                onSearchContent={handleGetKelas}
                tableFields={TABLE_PELANGGARAN_TABLE_FIELDS}
                onClickEdit={this._onClickEdit}
                onClickDelete={handleDeleteKelas}
              />
            </div> */}
          </form>
          </div>
        );
      }
}
AnalisaDispliner.propTypes = {
    
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
AnalisaDispliner.defaultProps = {
    
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
